import { useCallback, useEffect, useState } from 'react'
import { getUserTier } from '@api/tiers/getUserTier'
import { IUserTier } from '@api/tiers/types'
import { useNetwork, useWalletContext } from '@firestarter-private/firestarter-library'
import { useKYC } from '@contracts/hooks/useKYC'
import { isSolanaNetwork } from '@firestarter-private/firestarter-library/lib/utils/networks'
import { usePlatformSettings } from '@hooks/usePlatformSettings'

export interface UserTierInfo extends IUserTier {
  tierColor: string | null
  tierImage: string | null
}

export interface IUseFlameTier {
  userTierInfo: UserTierInfo | null,
  getTier: () => Promise<void>
  loading: boolean
}

export const useFlameTier = (): IUseFlameTier => {
  const { settings } = usePlatformSettings()
  const { account } = useWalletContext()
  const { KYCStatus, ethWalletAddress, getKYCStatus } = useKYC()
  const { currentNetworkId } = useNetwork()
  const [userTierInfo, setUserTier] = useState<UserTierInfo | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!KYCStatus && isSolanaNetwork(currentNetworkId as string)) {
      getKYCStatus()
    }
  }, [account, KYCStatus])

  const getTier = useCallback(async () => {
    if (!ethWalletAddress) return
    setLoading(true)
    const tierInfo = await getUserTier(ethWalletAddress)
    setUserTier(tierInfo ? {
      ...tierInfo,
      tierColor: '#C58BFF',
      tierImage: settings?.tiers.find(t => t.name === tierInfo.tier)?.icon ?? null
    } : null)
    setLoading(false)
  }, [ethWalletAddress, settings])

  useEffect(() => {
    if (ethWalletAddress) {
      getTier()
    }
  }, [ethWalletAddress])

  return {
    userTierInfo,
    getTier,
    loading
  }
}
